import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg48Carouselarrowright = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: [/*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "48-carouselarrowright_svg__a",
        width: "257.8%",
        height: "170.1%",
        x: "-80.9%",
        y: "-26.7%",
        filterUnits: "objectBoundingBox",
        children: [/*#__PURE__*/jsx("feMorphology", {
          "in": "SourceAlpha",
          operator: "dilate",
          radius: 1,
          result: "shadowSpreadOuter1"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: 2,
          "in": "shadowSpreadOuter1",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/jsx("feMorphology", {
          "in": "SourceAlpha",
          radius: 1,
          result: "shadowInner"
        }), /*#__PURE__*/jsx("feOffset", {
          dy: 2,
          "in": "shadowInner",
          result: "shadowInner"
        }), /*#__PURE__*/jsx("feComposite", {
          "in": "shadowOffsetOuter1",
          in2: "shadowInner",
          operator: "out",
          result: "shadowOffsetOuter1"
        }), /*#__PURE__*/jsx("feGaussianBlur", {
          "in": "shadowOffsetOuter1",
          result: "shadowBlurOuter1",
          stdDeviation: 2
        }), /*#__PURE__*/jsx("feColorMatrix", {
          "in": "shadowBlurOuter1",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        })]
      }), /*#__PURE__*/jsx("path", {
        id: "48-carouselarrowright_svg__b",
        d: "m24 12 10.4 12L24 36"
      })]
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h48v48H0z"
      }), /*#__PURE__*/jsxs("g", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [/*#__PURE__*/jsx("use", {
          xlinkHref: "#48-carouselarrowright_svg__b",
          fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
          filter: "url(#48-carouselarrowright_svg__a)"
        }), /*#__PURE__*/jsx("use", {
          xlinkHref: "#48-carouselarrowright_svg__b",
          stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
          strokeWidth: 2
        })]
      })]
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg48Carouselarrowright$1 = Svg48Carouselarrowright;

export { Svg48Carouselarrowright$1 as default };
